import { marginBottom } from "../App";
import { useState, useEffect, useContext } from "react";
import { Row, Col, Form, Container } from "react-bootstrap";
import { TextField, FormControl } from "@mui/material";
import Button from "@mui/material/Button";
import { UserDataContext } from "../components/UserDataContext";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../components/theme";
import { regex } from "../utils/regex";
import Alerts from "../components/Alerts";
import { useNavigate } from "react-router-dom";
import VN from "../components/VN";
import { apiRequest } from "../components/Config";

export default function PassChange({ userId }) {
  const [showApiResponse, setShowApiResponse] = useState(false);
  const [apiResponse, setApiResponse] = useState({});
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [repeatNewPassword, setRepeatNewPassword] = useState("");
  const [error, setError] = useState("");
  const { userData, setUserData } = useContext(UserDataContext);
  const navigate = useNavigate();

  const handleLogout = async () => {
    setUserData({
      ...userData,
      userId: 0,
      fullName: "",
    });

    try {
      await apiRequest("logout", "POST");
    } catch (error) {
      console.error(error);
    }
    navigate("/login");
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (
      repeatNewPassword === newPassword &&
      newPassword.length >= 8 &&
      regex.test(newPassword)
    ) {
      try {
        const response = await apiRequest("passchangeown", "POST", {
          userId: userId,
          oldpassword: oldPassword,
          newpassword: newPassword,
          repeatnewpassword: repeatNewPassword,
        });
        setError(response.error_msg);
        //console.log("PassChange: ", response);
      } catch (error) {
        setApiResponse({
          title: "Błąd",
          severity: "error",
          info: "Wystąpił błąd.",
        });
        console.error(error);
        setShowApiResponse(true);
      }
    } else {
      setApiResponse({
        title: "Błąd",
        severity: "error",
        info: "Hasło powinno mieć min. 8 znaków, dużą literę i znak specjalny!",
      });
      setShowApiResponse(true);
      setNewPassword("");
      setRepeatNewPassword("");
      return;
    }
  };

  useEffect(() => {
    if (error === 200) {
      setApiResponse({
        title: "Informacja",
        severity: "success",
        info: "Hasło użytkownika zostało zmienione. Zaloguj się z nowym hasłem.",
      });
      setShowApiResponse(true);
      const timeoutId = setTimeout(() => {
        handleLogout(navigate);
      }, 1000);
      return () => clearTimeout(timeoutId);
    }
    if (error === 250) {
      setApiResponse({
        title: "Informacja",
        severity: "error",
        info: "Hasło nie zostało zmienione. Prawdopodobnie nie podano właściwego hasła. Sprawdź, czy nie masz włączonego Caps Locka",
      });
      setShowApiResponse(true);
      const timeoutId = setTimeout(() => {
        handleLogout(navigate);
      }, 1000);
      return () => clearTimeout(timeoutId);
    }
  }, [error]);

  return (
    <div>
      <VN userData={userData} />
      {showApiResponse && (
        <Row style={{ marginBottom }}>
          <Alerts data={apiResponse} />
        </Row>
      )}
      <ThemeProvider theme={theme}>
        <Container>
          <Row style={{ marginBottom }}>
            <Col>
              <FormControl fullWidth>
                <TextField
                  label="Dotychczasowe hasło"
                  type="password"
                  variant="outlined"
                  value={oldPassword || ""}
                  onChange={(e) => setOldPassword(e.target.value)}
                  fullWidth
                />
              </FormControl>
            </Col>
          </Row>
          <Form>
            <Row style={{ marginBottom }}>
              <Col>
                <FormControl fullWidth>
                  <TextField
                    label="Nowe hasło"
                    type="password"
                    variant="outlined"
                    value={newPassword || ""}
                    onChange={(e) => setNewPassword(e.target.value)}
                    fullWidth
                  />
                </FormControl>
              </Col>
            </Row>

            <Row style={{ marginBottom }}>
              <Col>
                <FormControl fullWidth>
                  <TextField
                    label="Powtórz nowe hasło"
                    type="password"
                    variant="outlined"
                    value={repeatNewPassword || ""}
                    onChange={(e) => setRepeatNewPassword(e.target.value)}
                    fullWidth
                  />
                </FormControl>
              </Col>
            </Row>

            <Row>
              <Col>
                <Button variant="contained" onClick={handleSubmit}>
                  Zmień hasło
                </Button>
              </Col>
            </Row>
          </Form>
        </Container>
      </ThemeProvider>
    </div>
  );
}
